import React from "react"
import { useStaticQuery, graphql, Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Slider from "react-slick"

const OurClientsSlider = () => {

    const data = useStaticQuery(graphql`
        query {
            logoOne: file(relativePath: { eq: "austin-energy.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoTwo: file(relativePath: { eq: "Central_Market_Logo-RBMM.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoThree: file(relativePath: { eq: "EFE-propane.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoFour: file(relativePath: { eq: "TDA-Seafood_logo.red.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoFive: file(relativePath: { eq: "etec.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoSix: file(relativePath: { eq: "NatureSweet-Corporate-Logo.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoSeven: file(relativePath: { eq: "lpl-logo.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoEight: file(relativePath: { eq: "TDA-TexasWinesLogo-Final-01.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 300
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoNine: file(relativePath: { eq: "marathon.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoTen: file(relativePath: { eq: "Vital-Farms-logo.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoEleven: file(relativePath: { eq: "oncor-1.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoTwelve: file(relativePath: { eq: "Whataburger_logo.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoThirteen: file(relativePath: { eq: "Texas_Gas_Service.png" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
            logoFourteen: file(relativePath: { eq: "Whole_Foods_Market_201x_logo.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 200
                        placeholder: NONE
                        formats: [AUTO, JPG, PNG]
                    )
                }
            }
        }
    `)

    return(
        <ClientSection>
            <div className="client-img-container">
                <Slider {...settings}>
                    <div className="client-img">
                        <GatsbyImage image={data.logoOne.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoTwo.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoThree.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoFour.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoFive.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoSix.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoSeven.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoEight.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoNine.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoTen.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoEleven.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoTwelve.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoThirteen.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                    <div className="client-img">
                        <GatsbyImage image={data.logoFourteen.childImageSharp.gatsbyImageData} alt={"Client Logo"}/>
                    </div>
                </Slider>
            </div>
        </ClientSection>
    )
}

const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    variableWidth: true,
    centerMode: true,
    speed: 4000,
    autoplaySpeed: 2000,
    centerPadding: '60px',
    cssEase: "linear"
    
}

const ClientSection = styled.div`
    width: 100%;
    margin-bottom: 50px;
    position: relative;
    display: flex;
    justify-content: center;
    .client-img-container{
        width: 100%
    }
    .gatsby-image-wrapper {
        img{ 
            height: 100px;
        }
    }
    .client-img{
        margin-right: 60px;
        margin-left: 60px;
    }
    @media(max-width: 1080px) {
        .gatsby-image-wrapper {
            img{ 
                height: 80px;
            }
        }
    }
    @media(max-width: 767px) {
        .gatsby-image-wrapper {
            img{ 
                height: 60px;
            }
        }
        .client-img{
            margin-right: 40px;
            margin-left: 40px;
        }
    }
    @media(max-width: 359px) {
        .gatsby-image-wrapper {
            img{ 
                height: 40px;
            }
        }
        .client-img{
            margin-right: 20px;
            margin-left: 20px;
        }
    }
`

export default OurClientsSlider